import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Volume2, VolumeX } from 'lucide-react';
export function VideoSection() {
  return <section className="py-16 px-4 relative z-10" data-id="element-320">
      <div className="max-w-lg mx-auto text-center" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-322">
          <h2 className="text-3xl font-semibold text-[#3A3A3A] mb-4" data-id="element-323">
            ¿Qué es Ansiedad Exprés?
          </h2>
          <p className="text-lg text-[#7A7A7A] mb-8 max-w-xl mx-auto font-light" data-id="element-324">
            Mira este video y descubre cómo funciona el protocolo.
          </p>

          <div className="relative rounded-2xl overflow-hidden shadow-sm border border-[#E8E8E6] bg-white mx-auto" style={{
          aspectRatio: '9/16',
          maxHeight: '70vh'
        }} data-id="element-325">
            <iframe src="https://www.youtube.com/embed/5d4JH52x344?autoplay=1&mute=1&loop=1&playlist=5d4JH52x344&controls=1&rel=0&playsinline=1" className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Video Explicativo Ansiedad Exprés" data-id="element-326" />
          </div>

          <p className="text-sm text-[#7A7A7A] mt-4 flex items-center justify-center gap-2" data-id="element-327">
            <Volume2 className="w-4 h-4" data-id="element-328" /> Activa el sonido para escuchar la
            explicación completa
          </p>
        </motion.div>
      </div>
    </section>;
}